import React from "react";

class Filters extends React.Component {
    render() {

        const isHidden = this.props.isHidden;

        return ( 
          <div className="filters" hidden={isHidden}>
           

            {/* when this checkbox is selected, change the state somehow to add the additional extra filters 
            
            right now, it's adding the event.target.name to state, good!
            */}
        <fieldset>
            <legend>USB Types/Sizes</legend>
                <span className="aCheckbox">
                    <input type="checkbox" id="usbcCheckbox" name="usb-c" onClick={this.props.parentMethod}></input>
                    <label htmlFor="usbcCheckbox">USB-C</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="usbaCheckbox" name="usb-a" onClick={this.props.parentMethod}></input>
                    <label htmlFor="usbaCheckbox">USB-A</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="usbminibCheckbox" name="usb-mini-b" onClick={this.props.parentMethod}></input>
                    <label htmlFor="usbminibCheckbox">USB Mini-B</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="usbmicrobCheckbox" name="usb-micro-b" onClick={this.props.parentMethod}></input>
                    <label htmlFor="usbmicrobCheckbox">USB Micro-B</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="usb3microbCheckbox" name="usb-3.0-micro-b" onClick={this.props.parentMethod}></input>
                    <label htmlFor="usb3microbCheckbox">USB 3.0 Micro-B</label>
                </span>
        </fieldset>



        {/* //trs things */}
        <fieldset>
            <legend>TRS Sizes</legend>
                
                <span className="aCheckbox">
                    <input type="checkbox" id="quarterinchCheckbox" name="1/4-Inch" onClick={this.props.parentMethod}></input>
                    <label htmlFor="quarterinchCheckbox">1/4-inch</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="35mmCheckbox" name="3.5mm" onClick={this.props.parentMethod}></input>
                    <label htmlFor="35mmCheckbox">3.5mm</label>
                </span>


                <span className="aCheckbox">
                    <input type="checkbox" id="25mmCheckbox" name="2.5mm" onClick={this.props.parentMethod}></input>
                    <label htmlFor="25mmCheckbox">2.5mm</label>
                </span>
        </fieldset>

    {/* //firewire things */}
    <fieldset>
            <legend>Firewire Pin Sizes</legend>
                
                <span className="aCheckbox">
                    <input type="checkbox" id="9pinCheckbox" name="9-pin" onClick={this.props.parentMethod}></input>
                    <label htmlFor="9pinCheckbox">9-pin</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="6pinCheckbox" name="6-pin" onClick={this.props.parentMethod}></input>
                    <label htmlFor="6pinCheckbox">6-pin</label>
                </span>

                <span className="aCheckbox">
                    <input type="checkbox" id="4pinCheckbox" name="4-pin" onClick={this.props.parentMethod}></input>
                    <label htmlFor="4pinCheckbox">4-pin</label>
                </span>

    </fieldset>



          </div>
        )
    }
}
 
export default Filters;


// WEBPACK FOOTER //
// ./src/components/Filters.js